import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "intervenant-budget-content" }
const _hoisted_2 = { class: "intervenant-title" }
const _hoisted_3 = { class: "search-container" }
const _hoisted_4 = { class: "p-input-icon-left" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = {
  key: 0,
  class: "search-count"
}
const _hoisted_7 = { class: "intervenants-grid" }

import IntervenantBudgetCard from './IntervenantBudgetCard.vue';
import PaginationControls from '@/components/common/PaginationControls.vue';
// @ts-ignore
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

// Access i18n composable functions
interface IntervenantProps {
  intervenants?: any[];
  loading?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'IntervenantBudgetReport',
  props: {
    intervenants: {},
    loading: { type: Boolean }
  },
  setup(__props: any) {

const { t } = useI18n();

const props = __props;

// Search query
const searchQuery = ref('');

// Pagination state
const currentPage = ref<number>(1);
const pageSize = ref<number>(10);

// Reset pagination when search query changes
watch(searchQuery, () => {
  currentPage.value = 1;
});

// Computed properties
const filteredIntervenants = computed(() => {
  const query = searchQuery.value.toLowerCase().trim();
  
  if (!query) {
    return [...(props.intervenants || [])];
  }
  
  return (props.intervenants || []).filter((intervenant: any) => {
    return (
      intervenant.intervenantName?.toLowerCase().includes(query) ||
      intervenant.role?.toLowerCase().includes(query) ||
      intervenant.company?.toLowerCase().includes(query) ||
      intervenant.email?.toLowerCase().includes(query) ||
      intervenant.phone?.toLowerCase().includes(query)
    );
  });
});

const paginatedIntervenants = computed(() => {
  const start = (currentPage.value - 1) * pageSize.value;
  const end = start + pageSize.value;
  return filteredIntervenants.value.slice(start, end);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("i", { class: "pi pi-users" }, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('reports.intervenantBudgetReport')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, [
        _cache[3] || (_cache[3] = _createElementVNode("i", { class: "pi pi-search" }, null, -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
          type: "text",
          class: "search-input",
          placeholder: _ctx.$t('common.search')
        }, null, 8, _hoisted_5), [
          [_vModelText, searchQuery.value]
        ])
      ]),
      (searchQuery.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(filteredIntervenants.value.length) + " " + _toDisplayString(_ctx.$t('common.results')), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedIntervenants.value, (intervenant) => {
        return (_openBlock(), _createBlock(IntervenantBudgetCard, {
          key: intervenant.intervenantId,
          intervenant: intervenant
        }, null, 8, ["intervenant"]))
      }), 128))
    ]),
    _createVNode(PaginationControls, {
      currentPage: currentPage.value,
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
      pageSize: pageSize.value,
      totalItems: filteredIntervenants.value.length,
      itemsLabel: _ctx.$t('reports.intervenants.title').toLowerCase()
    }, null, 8, ["currentPage", "pageSize", "totalItems", "itemsLabel"])
  ]))
}
}

})